import React from "react";
import { Button } from "@sonder/ui/source/styled/fragments/Button";
import { ButtonList } from "@sonder/ui/source/styled/fragments/ButtonList";

const padNumber = (item: string | number) =>
  typeof item === "number" ? item.toString().padStart(2, "0") : item;

export type Meridiem = "AM" | "PM";
interface TimePickerListProps {
  className?: string;
  selected: Meridiem | number;
  items: (Meridiem | number)[];
  onSelect(value: Meridiem | number): void;
}
export const TimePickerList = ({
  className,
  selected,
  items,
  onSelect,
}: TimePickerListProps) => (
  <ButtonList className={className}>
    {items.map((item: Meridiem | number) => (
      <Button
        noBorder
        key={item}
        selected={selected === item}
        onClick={() => onSelect(item)}
      >
        {padNumber(item)}
      </Button>
    ))}
  </ButtonList>
);
